import { all, put, call, takeLatest } from "redux-saga/effects";

import auth from "../../api/auth";
import * as types from "./authActionsTypes";


function *login ({ payload }) {
  yield put({ type: types.TOGGLE_PROCESSING, payload: true });

  try {
    const response = yield call(auth.login, payload);
    yield put({ type: types.LOGIN_REQUEST_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.AUTH_REQUEST_ERROR, error });
  } finally {
    yield put({ type: types.TOGGLE_PROCESSING, payload: false });
  }
}

function *register ({ payload }) {
  yield put({ type: types.TOGGLE_PROCESSING, payload: true });

  try {
    const response = yield call(auth.register, payload);
    yield put({ type: types.REGISTER_REQUEST_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.AUTH_REQUEST_ERROR, error });
  } finally {
    yield put({ type: types.TOGGLE_PROCESSING, payload: false });
  }
}

function *logout () {
  yield put({ type: types.TOGGLE_PROCESSING, payload: true });

  try {
    const response = yield call(auth.logout);
    yield put({ type: types.LOGOUT_REQUEST_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.AUTH_REQUEST_ERROR, error });
  } finally {
    yield put({ type: types.TOGGLE_PROCESSING, payload: false });
  }
}

function *resetPassword({ payload: email }) {
  yield put({ type: types.TOGGLE_PROCESSING, payload: true });

  try {
    const response = yield call(auth.resetPassword, email);
    yield put({ type: types.RESET_PASSWORD_REQUEST_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.AUTH_REQUEST_ERROR, error });
  } finally {
    yield put({ type: types.TOGGLE_PROCESSING, payload: false });
  }
}

function *resetPasswordCheck({ payload }) {
  yield put({ type: types.TOGGLE_PROCESSING, payload: true });

  try {
    const { callback, ...data } = payload;
    const response = yield call(auth.resetPasswordCheck, data);
    if (typeof callback === "function") callback();
    yield put({ type: types.RESET_PASSWORD_CHECK_REQUEST_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.AUTH_REQUEST_ERROR, error });
  } finally {
    yield put({ type: types.TOGGLE_PROCESSING, payload: false });
  }
}


export default function *() {
  yield all([
    yield takeLatest(types.LOGIN_REQUEST, login),
    yield takeLatest(types.REGISTER_REQUEST, register),
    yield takeLatest(types.LOGOUT_REQUEST, logout),
    yield takeLatest(types.RESET_PASSWORD_REQUEST, resetPassword),
    yield takeLatest(types.RESET_PASSWORD_CHECK_REQUEST, resetPasswordCheck),
  ])
}
